// extracted by mini-css-extract-plugin
export var labelWrapper = "_9j-0";